'use strict';

class PayAsYouGoCreditSection {
	constructor(props = {}) {
		console.log('PayAsYouGoCreditSection::constructor(%o)', props);

		this.minQuantity = null;
		this.maxQuantity = null;

		const formBuyPayg = document.getElementById('form_buy_payg');

		this.form = {
			self: formBuyPayg,
			quantityInput: formBuyPayg.querySelector('input[name="products[0][quantity]"]'),
			predefinedAmountsHolder: formBuyPayg.querySelector('.predefined_amounts'),
			predefinedAmountsLabels: formBuyPayg.querySelectorAll('.pa_label'),
			submit: formBuyPayg.querySelector('#payg_submit'),
			customAmount: formBuyPayg.querySelector('#payg_custom_amount'),
			lastActiveLabel: formBuyPayg.querySelector('.active').nextElementSibling.value,
			jqueryCustomAmount: $('#payg_custom_amount'),
			timer: null,
			messageErrorActive: false,
			messageErrorTemplate: `
				<div class='tooltip tooltip-error' role='tooltip'>
					<div class='tooltip-arrow'></div>
					<div class='tooltip-inner'></div>
				</div>`,
		};

		Object.assign(this, props);

		this.pageEvents();
	}

	timerOn(subject) {
		console.log('PayAsYouGoCreditSection::timerOn()');
		this.form.timer = setTimeout(() => subject(), 700);
	}

	timerOff() {
		if (this.form.timer) {
			console.log('PayAsYouGoCreditSection::timerOff()');
			clearTimeout(this.form.timer);
			this.form.timer = null;
		}
	}

	messageErrorOn(message) {
		if (!this.form.messageErrorActive && this.form.messageErrorTemplate) {
			console.log('PayAsYouGoCreditSection::messageErrorOn()');
			this.form.jqueryCustomAmount.tooltip({
				title: message,
				trigger: 'manual',
				template: this.form.messageErrorTemplate,
			});
			this.form.jqueryCustomAmount.attr('data-original-title', message).tooltip('fixTitle')
				.tooltip('show');
			this.form.messageErrorActive = true;
		}
	}

	messageErrorOff() {
		if (this.form.messageErrorActive) {
			console.log('PayAsYouGoCreditSection::messageErrorOff()');
			this.form.jqueryCustomAmount.tooltip('hide');
			this.form.messageErrorActive = false;
		}
	}

	inputErrorOn() {
		if (!this.form.customAmount.parentElement.classList.contains('has-error')) {
			console.log('PayAsYouGoCreditSection::inputErrorOn()');
			this.form.customAmount.parentElement.classList.add('has-error');
		}
	}

	inputErrorOff() {
		if (this.form.customAmount.parentElement.classList.contains('has-error')) {
			console.log('PayAsYouGoCreditSection::inputErrorOff()');
			this.form.customAmount.parentElement.classList.remove('has-error');
		}
	}

	submitButtonOn() {
		if (this.form.submit.disabled === true) {
			console.log('PayAsYouGoCreditSection::submitButtonOn()');
			this.form.submit.disabled = false;
		}
	}

	submitButtonOff() {
		if (this.form.submit.disabled === false) {
			console.log('PayAsYouGoCreditSection::submitButtonOff()');
			this.form.submit.disabled = true;
		}
	}

	activeLabelClassOn(elem) {
		if (!elem.classList.contains('active')) {
			console.log('PayAsYouGoCreditSection::activeLabelClassOn()');
			elem.classList.add('active');
		}
	}

	activeLabelClassOff() {
		if (this.form.predefinedAmountsHolder.querySelector('.active')) {
			console.log('PayAsYouGoCreditSection::activeLabelClassOff()');
			this.form.predefinedAmountsHolder.querySelector('.active').classList.remove('active');
		}
	}

	noQuantityInputValue() {
		if (this.form.quantityInput.value !== '') {
			console.log('PayAsYouGoCreditSection::noQuantityInputValue()');
			this.form.quantityInput.value = '';
		}
	}

	activeLabelQuantityInputValue() {
		if (this.form.predefinedAmountsHolder.querySelector('.active')) {
			console.log('PayAsYouGoCreditSection::activeLabelQuantityInputValue()');
			const activeLabelValue = this.form.predefinedAmountsHolder.querySelector('.active').nextElementSibling.value;
			this.form.quantityInput.value = this.form.lastActiveLabel = activeLabelValue;
		}
	}

	lastClickedActiveLabel() {
		const lastActiveInput = this.form.predefinedAmountsHolder.querySelector(`input[value='${this.form.lastActiveLabel}']`);
		if (!lastActiveInput.previousElementSibling.classList.contains('active')) {
			console.log('PayAsYouGoCreditSection::lastClickedActiveLabel()');
			lastActiveInput.previousElementSibling.classList.add('active');
		}
	}

	formOn() {
		console.log('PayAsYouGoCreditSection::formOn()');
		this.submitButtonOn();
		this.inputErrorOff();
		this.messageErrorOff();
		this.timerOff();
	}
	formOff(message) {
		console.log('PayAsYouGoCreditSection::formOff()');
		this.noQuantityInputValue();
		this.submitButtonOff();
		this.inputErrorOn();
		this.messageErrorOn(message);
	}

	formOffWithTimer(message) {
		console.log('PayAsYouGoCreditSection::formOffWithTimer()');
		this.noQuantityInputValue();
		this.submitButtonOff();
		this.timerOn(() => {
			this.inputErrorOn();
			this.messageErrorOn(message);
		});
	}

	updateSelectedAmount(selectedAmount) {
		console.log('PayAsYouGoCreditSection::updateSelectedAmount()');
		this.activeLabelClassOff();
		this.activeLabelClassOn(selectedAmount);
		this.activeLabelQuantityInputValue();
		this.formOn();
	}

	updateCustomAmount(customAmount) {
		console.log('PayAsYouGoCreditSection::updateCustomAmount()');
		const value = customAmount.target.value;
		const amount = new RegExp(/^\d*?[\.,]?\d*?$/).test(value) ? parseFloat(value) : false;

		this.activeLabelClassOff();
		this.timerOff();

		if (value === '') {
			this.lastClickedActiveLabel();
			this.activeLabelQuantityInputValue();
			this.formOn();
		} else {
			if (!amount) {
				this.formOff(it('ERROR_INVALID_AMOUNT'));
			} else {
				if (amount > this.maxQuantity) {
					this.formOff(it('MAXIMUM_AMOUNT_IS'));
				} else if (amount < this.minQuantity) {
					this.formOffWithTimer(it('MINIMUM_AMOUNT_IS'));
				} else {
					this.form.quantityInput.value = amount;
					this.formOn();
				}
			}
		}
	}

	pageEvents() {
		const that = this;

		if (that.form.predefinedAmountsLabels.length > 0) {
			that.form.predefinedAmountsLabels.forEach(option => {
				option.addEventListener('click', e => {
					if (e.target.classList.contains('active')) {
						return;
					}
					that.updateSelectedAmount(option);
				});
			});
		}

		if (that.form.customAmount) {
			that.form.customAmount.addEventListener('input', amount => {
				that.updateCustomAmount(amount);
			});
		}
	}
}

window.addEventListener('DOMContentLoaded', () => {
	try {
		new PayAsYouGoCreditSection(quantityLimiter || {});
	} catch (e) {
		console.error(e);
	}
});
